import { UtilsService } from './../../components/utils/utils.service';
import { CatalogueService } from './../../components/catalogue/catalogue.service';
import { ENV } from 'environments/environment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from '../../components/common/session/session.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import {TranslateService} from "@ngx-translate/core";
import {DetailsService} from "../../components/details/details.service";

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.scss']
})
export class MapsComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  sub;
  eventData;
  sanitizedUrl: any;
  exhibitorId: string = '';
  catalogueName: string = '';

  constructor(private activatedRoute:ActivatedRoute,
              private route: ActivatedRoute,
              private sessionService: SessionService,
              private sanitizer: DomSanitizer,
              private titleService: Title,
              public catalogueService: CatalogueService,
              private utilsService: UtilsService,
              private translateService: TranslateService,
              private detailsService: DetailsService) {

    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || '';

  }

  setSanitizedUrl(exhibitorId = '{exhibitorId}') {
    const baseUri: string = ENV.MAPS.BASE_VISOR_URI;

    let lang = (function (x) {
      switch (x) {
        case 'es': return 'es_ES';
        case 'ca': return 'ca_ES';
        case 'en': return 'en_GB';
        default : return 'es_ES';
      }
    })

    const language = `language=${lang(this.translateService.currentLang)}`;
    const eventCode = `eventCode=${this.eventData.sapCode}`;
    const featuredColor = escape(this.eventData.featuredColor);
    const sponsoredColor = escape(this.eventData.sponsoredColor);
    const exhibitorsUrl: string = encodeURIComponent(ENV.APP.USEARCH_API + `/us/unifiedSearch/map/exhibitors?` + language + `&filter=ONLY_EXHIBITORS&` + eventCode);
    const sectorsUrl: string = encodeURIComponent(ENV.APP.BACKEND_API + `/sectors/search/findByCatalogueEventName?eventName=${this.catalogueName}&` + language);
    const externalLinks: string = encodeURIComponent(ENV.APP.FRONTOFFICE_URL + `/${this.eventData.id}` + `/${this.catalogueName}/exhibitor/${exhibitorId}/detail?{lang}`);
    const catalogueProperties: string = JSON.parse(this.sessionService.get('catalogueProperties'));
    const standLabelStrategy = this.detailsService.getPropertyByKey('map.stand.text.visualization.mode') || 'ALL_EXHIBITORS';

    let url = baseUri
        + `?` + eventCode
        + `&exhibitorsURL=` + exhibitorsUrl
        + `&sectorsURL=` + sectorsUrl
        + `&search=true`
        + `&showLogo=false`
        + `&externalLinks=` + externalLinks
        + `&featuredColor=` + featuredColor
        + `&sponsoredColor=` + sponsoredColor
        + `&defaultExhibitorImage=` + catalogueProperties['defaultExhibitorImage']
        + `&` + language
        + `&standLabelStrategy=` + standLabelStrategy;

    if (exhibitorId !== '{exhibitorId}')
      url += `&exhibitorId=` + exhibitorId;

    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  
  executeDetails() {
    let getDetailsJsonIn = {
      sapCode: this.catalogueService.getProperty('sapCode')
    };
    this.getDetailsJson(getDetailsJsonIn);
    this.getDetailsJson(getDetailsJsonIn, true);
  }

  getDetailsJson(getDetailsJsonIn, local = false) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.getDetailsJson(getDetailsJsonIn, local)
      .subscribe((data: object) => {
        this.getDetailsJsonOk(data, local);
      },
        error => {
          this.getDetailsJsonError(error);
        });

  }

  getDetailsJsonOk(data, local) {

    this.loader.count--;
    this.detailsService.setDetailsJson(data, local);
    this.detailsService.setIsUpdateDetails(true);

  }

  getDetailsJsonError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.detailsService.setIsUpdateDetails(true);

  }


  ngOnInit() {

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    this.executeDetails();

    this.route.queryParams.subscribe(params => {
      if(params && params['exhibitorId']){
        this.exhibitorId = params['exhibitorId'];
        this.setSanitizedUrl(this.exhibitorId);
      }
    });

    if(this.utilsService.isEmpty(this.exhibitorId))
      this.setSanitizedUrl();


    this.titleService.setTitle(this.catalogueService.getProperty('label'));

  }

}
